angular.module('mercury.modules.time.clock', []);
